/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useEffect, useState } from "react";
import { number, object, shape, any, func, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { InfiniteStoryBase, WithPreview } from "@quintype/components";

import TextStory from "../../story-templates/text";
import LiveBlog from "../../story-templates/live-blog";
import LongForm from "../../story-templates/long-form";
import VideoStory from "../../story-templates/video";
import PhotoStory from "../../story-templates/photo-story";
import ExplainerStory from "../../story-templates/explainer-story";

import { getStoryPageWruData, loadStoriesForInfiniteScroll } from "../../helper/api";
import { setWruData } from "../../helper/actions";
import { readCookie } from "../../helper/cookies";
import { resizeIframes, addGTMPageVariables } from "../../utils/utils";
import { StoryTopResponsiveContainer } from "../../rows/ad-free";

import "./story.m.css";

const pickTemplate = {
  text: TextStory,
  podcast: TextStory,
  "live-blog": LiveBlog,
  "long-form": LongForm,
  video: VideoStory,
  review: VideoStory,
  photo: PhotoStory,
  explainer: ExplainerStory,
};

const StoryPageTemplates = ({ index, story, params, merchantId, setWruData, publisherName, initialPath }) => {
  useEffect(() => {
    window.dataLayer.push({
      "story-index": index,
    });
  }, [index]);

  useEffect(() => {
    window.localStorage.setItem("sym_initiate_page", initialPath);

    if (publisherName === "quint-hindi") {
      addGTMPageVariables(story, "WEB", ++index, null);
    }

    if (index > 0) {
      window.dataLayer.push({
        "infinite-scroll": "true",
      });
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (params && params.cardId) {
        document.getElementById(params.cardId) &&
          document.getElementById(params.cardId).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
      }
    }, 2000);
  }, [params]);

  useEffect(() => {
    const thinmint = readCookie("thinmint");
    getStoryPageWruData(story.id, thinmint, merchantId).then((data) => setWruData(data, story.id));
    resizeIframes();
  }, []);

  const Component = pickTemplate[story["story-template"]] || TextStory;

  return (
    <div styleName="quint-story" className="container">
      <StoryTopResponsiveContainer mobile="storyPrem1" desktop="storyTopAd" story={story} />
      <Component publisherName={publisherName} story={story} index={index} />
    </div>
  );
};

StoryPageTemplates.propTypes = {
  index: number,
  story: object,
  otherProp: any,
  merchantId: number,
  setWruData: func,
  params: object,
  publisherName: string,
  initialPath: string,
};

const mapStateToProps = (state) => ({
  merchantId: get(state, ["qt", "config", "publisher-attributes", "wru_id"]),
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setWruData: (data, storyId) => dispatch(setWruData(data, storyId)),
});

const StoryPageBase = connect(mapStateToProps, mapDispatchToProps)(StoryPageTemplates);

export function StoryPage(props) {
  const [isBot, setIsBot] = useState(false);

  const renderSingleStoryComponent = (
    <StoryPageBase index={0} story={props.data.story} initialPath={props.currentPath} />
  );
  useEffect(() => {
    if (window.navigator) {
      setIsBot(/bot|googlebot|crawler|spider|robot|crawling/i.test(window.navigator.userAgent));
    }
  }, []);

  const enableInfiniteScroll = get(props, ["config", "publisher-attributes", "enable_infinite_scroll"], true);

  if (!enableInfiniteScroll || isBot) {
    return renderSingleStoryComponent;
  }

  return (
    <InfiniteStoryBase
      {...props}
      render={(storyProps) => <StoryPageBase {...storyProps} initialPath={props.currentPath} />}
      loadItems={loadStoriesForInfiniteScroll}
      onInitialItemFocus={(item) =>
        app.registerPageView({ pageType: "story-page", data: { story: item.story } }, `/${item.story.slug}`)
      }
      onItemFocus={(item, index) => {
        console.log(`Story In View: ${item.story.headline}`);
        addGTMPageVariables(item.story, "WEB", ++index, null);
      }}
    />
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object,
  }),
  currentPath: string,
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story),
  })
);
